import { useState } from "react";
import T from "@/components/T";
import {
  Gamepad2,
  Youtube,
  Instagram,
  ExternalLink,
  X,
} from "lucide-react";

const SOCIALS = [
  {
    id: "discord",
    label: "Discord",
    Icon: Gamepad2,
    color: "#5865F2",
    url: "https://discord.gg/mh5Ub8qHeP",
    title: "Join our Discord",
    description: "Meet the community, receive announcements and chat with other players.",
  },
  {
    id: "x",
    label: "X",
    Icon: X,
    color: "#E2DFD8",
    url: "https://x.com/grimwalkerSM",
    title: "Follow us on X",
    description: "News, updates, codes.",
  },
];

export default function SocialView() {
  const [tab, setTab] = useState("discord");

  const current = SOCIALS.find((s) => s.id === tab);

  return (
    <div className="space-y-2">
      <div
        className="panel p-2 flex gap-1 flex-wrap"
        data-testid="social-subnav"
      >
        {SOCIALS.map((s) => {
          const Icon = s.Icon;
          const active = tab === s.id;

          return (
            <button
              key={s.id}
              onClick={() => setTab(s.id)}
              className={`flex-1 py-2 px-2 border font-heading text-[10px] tracking-widest uppercase flex items-center justify-center gap-1 ${
                active
                  ? "border-[#E55A00] text-[#E55A00]"
                  : "border-[#262626] text-[#8c8c8c]"
              }`}
            >
              <Icon
                className="w-3 h-3"
                strokeWidth={1.5}
                style={{
                  color: active ? "#E55A00" : s.color,
                }}
              />

              {s.label}
            </button>
          );
        })}
      </div>

      <div className="panel p-5 text-center space-y-4">
        <div>
          <current.Icon
            className="w-10 h-10 mx-auto mb-3"
            style={{ color: current.color }}
            strokeWidth={1.5}
          />

          <h2 className="font-heading tracking-widest uppercase text-[#E2DFD8]">
            {current.title}
          </h2>

          <p className="text-xs text-[#8c8c8c] mt-2">
            {current.description}
          </p>
        </div>

        <a
          href={current.url}
          target="_blank"
          rel="noreferrer"
          className="inline-flex items-center gap-2 border border-[#E55A00]
                     text-[#E55A00] px-4 py-2 font-heading tracking-widest
                     uppercase text-xs hover:bg-[#E55A00] hover:text-black
                     transition-colors"
        >
          <ExternalLink className="w-3 h-3" />
          Open {current.label}
        </a>
      </div>
    </div>
  );
}